import { render } from "./Loading.vue?vue&type=template&id=d42a4448&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=d42a4448&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kedaq\\Desktop\\pruebaBodyTech\\pruebaspotify\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d42a4448"]])

export default __exports__